import { useCallback } from 'react'
import PageEntrance from '~components/motion/page-entrance'
import Submitted from '~containers/app/ask-a-vet/6_submitted'
import usePopStateEventListener from '~hooks/use-pop-state-event-listener'
import getRootPath from '~utils/app/get-root-path'

import { createFileRoute, useNavigate } from '@tanstack/react-router'

export const Route = createFileRoute('/samsung/smart-things/(app)/ask-a-vet/submitted')({
  component: RouteComponent,
  validateSearch: (params: { consultationId: string }) => {
    if (params.consultationId) {
      return {
        consultationId: params.consultationId,
      }
    }
    throw new Error('consultationId is required')
  },
})

function RouteComponent() {
  const navigate = useNavigate()
  const { consultationId } = Route.useSearch()
  /**
   * @TODO: consultation metadata 에 대한 UAF 가 필요한지 체크
   */

  const handlePopState = useCallback(() => {
    setTimeout(() => {
      navigate({
        to: `${getRootPath()}/`,
        replace: true,
        resetScroll: true,
      })
    }, 100)
  }, [navigate])

  usePopStateEventListener({
    onPopState: handlePopState,
  })
  return (
    <PageEntrance>
      <Submitted submittedConsultationId={consultationId} />
    </PageEntrance>
  )
}
